import { Session, Tenant } from '@/types/core-types'
import { cloneDeep } from 'lodash'
import { use } from 'react'
import { proxy, snapshot, subscribe, useSnapshot } from 'valtio'

const initialState = {
  session: undefined,
  tenants: {},
  context: {
    tenant: undefined,
  },
  history: {},
  favorites: {},
  notifications: {},
  rememberMe: false,
}

export type CoreContext = {
  session?: Session
  tenants: Record<string, Tenant>
  context: {
    tenant?: string
  }
  history: Record<string, History>
  notifications: Record<string, Notification>
  rememberMe: boolean
}
export const coreContext = proxy<CoreContext>(initialState)

const actions = {
  setTenant: (tenant: Tenant) => {
    coreContext.tenants[tenant.id] = tenant
    coreContext.context.tenant = tenant.id
  },
  setSession: (session: Session) => {
    coreContext.session = session
  },
  load: () => {
    const storedData: any =
      localStorage.getItem('.corectx') != null ? JSON.parse(sessionStorage.getItem('.corectx')!) : {}
    if (storedData?.session != null) coreContext.session = { ...coreContext.session, ...storedData }
  },
  save: () => {
    const { ...storedData }: any = coreContext
    ;(coreContext.rememberMe ? localStorage : sessionStorage).setItem('.corectx', JSON.stringify(storedData))
  },
  clearSession: () => {
    coreContext.session = undefined
  },
  reset: () => {
    const resetObj = cloneDeep(initialState)
    Object.keys(resetObj).forEach((key) => {
      ;(coreContext as any)[key] = cloneDeep((resetObj as any)[key])
    })
  },
}

subscribe(coreContext, () => {
  localStorage.setItem('.cctx', JSON.stringify(coreContext))
})

export const useTenant = (id?: string) => {
  const { context } = useSnapshot(coreContext)
  const tenantId = id != null ? id : context?.tenant
  const tenant = tenantId != null ? coreContext.tenants[tenantId] : undefined
  return tenant
}

export function useCoreContext() {
  const { session, tenants, history, context, notifications } = useSnapshot(coreContext)
  const tenant = useTenant()
  return { session, tenants, history, context, tenant, notifications, actions }
}
